export interface PlaylistAudioItem {
    type?: 'exercise' | 'tts' | 'recording';
    exerciseId?: string; // optional now
    key?: string; // optional now
    text?: string; // for TTS
    audioUrl?: string; // for TTS, legacy
    fileId?: string; // for Secure audio (TTS and Recording)
    repeat: number;
    transpose?: number;
}

export class PlaylistReference {
    id: string;
    name: string;
    timestamp: number;
    authorId?: string;
    authorName?: string;

    constructor(id: string, name: string, timestamp: number, authorId?: string, authorName?: string) {
        this.id = id;
        this.name = name;
        this.timestamp = timestamp;
        this.authorId = authorId;
        this.authorName = authorName;
    }

    static fromJson(json: any): PlaylistReference {
        return new PlaylistReference(
            json.id,
            json.name,
            json.timestamp ?? new Date().getTime(),
            json.authorId,
            json.authorName
        );
    }

    toJson(): any {
        return {
            id: this.id,
            name: this.name,
            timestamp: this.timestamp,
            authorId: this.authorId,
            authorName: this.authorName
        };
    }
}

export default class Playlist {
    id: string;
    name: string;
    audio: PlaylistAudioItem[];
    timestamp: number;
    userIds: string[];
    editorIds: string[];
    isPublic: boolean;
    authorId: string;
    authorName: string;

    constructor(
        id: string,
        name: string,
        audio: PlaylistAudioItem[],
        timestamp: number,
        userIds: string[],
        editorIds: string[],
        isPublic: boolean = false,
        authorId: string = "",
        authorName: string = ""
    ) {
        this.id = id;
        this.name = name;
        this.audio = audio;
        this.timestamp = timestamp;
        this.userIds = userIds;
        this.editorIds = editorIds;
        this.isPublic = isPublic;
        this.authorId = authorId;
        this.authorName = authorName;
    }

    static fromJson(json: any): Playlist {
        return new Playlist(
            json.id,
            json.name,
            json.audio ?? [],
            json.timestamp ?? new Date().getTime(),
            json.userIds ?? [],
            json.editorIds ?? [],
            json.isPublic ?? false,
            json.authorId ?? "",
            json.authorName ?? ""
        );
    }

    isOwner(uid: string): boolean {
        return this.authorId === uid || this.editorIds.includes(uid);
    }

    isMember(uid: string): boolean {
        return this.userIds.includes(uid);
    }

    hasAccess(uid: string): boolean {
        return this.isPublic || this.isMember(uid) || this.isOwner(uid);
    }

    toJson(): any {
        return {
            id: this.id,
            name: this.name,
            audio: this.audio,
            timestamp: this.timestamp,
            userIds: this.userIds,
            editorIds: this.editorIds,
            isPublic: this.isPublic,
            authorId: this.authorId,
            authorName: this.authorName
        };
    }
}
